//dependencias
import React, { Component } from 'react';

//componentes
import ReporteF from './reporteF'

class Index extends Component {

    render(){
        return(
            <div>
                <ReporteF />
            </div>
        );
    }

}
export default Index;